import { gql } from '@apollo/client';

export default class SplitAmountSettingsMutate {
    static UPDATE_ACCOUNT_BANK_INFORMATION = gql`
        mutation updateAccountBankInformation($records: [AccountCOABankingInput!]!) {
            updateAccountBankInformation(records: $records)
        }`;
}
